import React, { useEffect } from "react";
import ModalBooking from "../Modal-booking";

export function parseDateKey(dateKey) {
  const [month, day, year] = dateKey.split("-").map(Number);
  return new Date(year, month - 1, day);
}
export function formatBookingDate(dateKey) {
  return dateKey ? parseDateKey(dateKey).toLocaleDateString("uk-UA", { day: "numeric", month: "long" }) : "";
}

export default function Calendar({ refreshTime, selectedTimes, currentUser, onBooked, loading, error }) {
  const [selectedDate, setSelectedDate] = React.useState(null);
  useEffect(() => { setSelectedDate(null); }, [currentUser]);
  const userTimes = selectedTimes[currentUser] || {};
  const availableDays = Object.keys(userTimes).filter((date) => userTimes[date]?.length)
    .sort((a, b) => parseDateKey(a) - parseDateKey(b));
  const validDate = selectedDate && userTimes[selectedDate]?.length ? selectedDate : null;

  return (
    <section className="studio-schedule" aria-labelledby="schedule-title" aria-busy={loading}>
      <div className="booking-section-heading"><span className="step-number">02</span><div><p>ЗНАЙДИ СВІЙ МОМЕНТ</p><h2 id="schedule-title">Коли зустрінемось?</h2></div></div>
      <div className="schedule-caption"><span>Доступні дати</span><span>За київським часом</span></div>
      {loading ? <div className="schedule-empty" role="status">Завантажуємо розклад…</div> : error ? (
        <div className="schedule-empty" role="alert"><p>{error}</p><button className="studio-secondary" onClick={refreshTime}>Спробувати ще раз</button></div>
      ) : availableDays.length ? (
        <div className="date-options">
          {availableDays.map((date) => (
            <button type="button" key={date} className={`date-option${validDate === date ? " is-selected" : ""}`}
              aria-pressed={validDate === date} onClick={() => setSelectedDate(date)}>
              <span className="date-option-top"><span>{parseDateKey(date).toLocaleDateString("uk-UA", { weekday: "short" })}</span><span aria-hidden="true">{validDate === date ? "✓" : "↗"}</span></span>
              <strong>{parseDateKey(date).getDate()}</strong><span className="date-month">{formatBookingDate(date).replace(/^\d+\s*/, "")}</span>
              <span className="date-availability">{userTimes[date].length} вільн. год.</span>
            </button>
          ))}
        </div>
      ) : <div className="schedule-empty"><strong>Нові дати вже незабаром</strong><p>Спробуй обрати іншого тренера або завітай пізніше.</p></div>}
      {!!availableDays.length && !error && !loading && <>
        <div className="schedule-preview"><span>{validDate ? `Вільний час · ${formatBookingDate(validDate)}` : "Обери дату, щоб переглянути години"}</span>
          {validDate && <div>{userTimes[validDate].map((time) => <span key={time}>{time}</span>)}</div>}
        </div>
        <ModalBooking key={currentUser} selectedDate={validDate} slots={userTimes[validDate] || []} trainer={currentUser} refreshTime={refreshTime} onBooked={onBooked} />
        <p className="schedule-footnote">Обери час і залиш контактні дані — ми чекатимемо на тебе.</p>
      </>}
    </section>
  );
}
